import * as base64 from 'base64-js';
async function decryptWithManagedIV(encryptedDataBase64: string, encryptionKeyBase64: string) {
  const encryptedBytes = base64.toByteArray(encryptedDataBase64);
  const iv = encryptedBytes.slice(0, 16);
  const data = encryptedBytes.slice(16);

  const cryptoKey = await window.crypto.subtle.importKey(
    'raw',
    base64.toByteArray(encryptionKeyBase64),
    { name: 'AES-CBC' },
    false,
    ['decrypt']
  );

  const decryptedData = await window.crypto.subtle.decrypt({ name: 'AES-CBC', iv: iv }, cryptoKey, data);

  return new TextDecoder().decode(decryptedData);
}
export async function DecryptAndDestruct(
  encryptedDataBase64: string,
  encryptionKeyBase64: string
): Promise<{
  RecordId: string;
  ContactName: string;
  ContactPhoneNumber: string | undefined;
  Type: string | undefined;
  ProviderId: string;
  providerName: string;
}> {
  return decryptWithManagedIV(encryptedDataBase64, encryptionKeyBase64)
    .then(decryptedData => {
      const keyValuePairArray: string[] = decryptedData.split('&');
      const variables: { [key: string]: string } = {};
      //console.log(decryptedData);
      keyValuePairArray.forEach(keyValuePair => {
        const [key, value] = keyValuePair.split('=');
        variables[key] = value;
      });

      const RecordId: string = variables['RecordId'] || '';
      const ContactName: string = variables['ContactName'] || '';
      const ContactPhoneNumber: string | undefined = variables['ContactPhoneNumber'];
      const Type: string = variables['Type'];
      const ProviderId: string = variables['ProviderId'] || '';
      const providerName: string = variables['providerName'] || '';

      return {
        RecordId: RecordId,
        ContactName: ContactName,
        ContactPhoneNumber: ContactPhoneNumber,
        Type: Type || 'Host',
        ProviderId: ProviderId,
        providerName: providerName,
      };
    })
    .catch(error => {
      console.error('Error:', error);
      throw error; // Rethrow the error to be caught by the caller if needed.
    });
}
export async function encryptWithManagedIV(
  data: {
    RecordId: string;
    ContactName: string;
    ContactPhoneNumber: string;
    ProviderId: string;
    providerName: string;
    Type: string;
  },
  encryptionKeyBase64: string
): Promise<string> {
  const plaintext = `RecordId=${data.RecordId}&ContactName=${data.ContactName}&ContactPhoneNumber=${data.ContactPhoneNumber}&ProviderId=${data.ProviderId}&Type=${data.Type}&providerName=${data.providerName}`;

  const cryptoKey = await window.crypto.subtle.importKey(
    'raw',
    base64.toByteArray(encryptionKeyBase64),
    { name: 'AES-CBC' },
    false,
    ['encrypt']
  );

  // Generate a random IV (Initialization Vector) for AES-CBC encryption
  const iv = window.crypto.getRandomValues(new Uint8Array(16));

  const encryptedData = await window.crypto.subtle.encrypt(
    { name: 'AES-CBC', iv: iv },
    cryptoKey,
    new TextEncoder().encode(plaintext)
  );

  const combinedData = new Uint8Array(16 + encryptedData.byteLength);
  combinedData.set(iv, 0);
  combinedData.set(new Uint8Array(encryptedData), 16);

  const encryptedDataBase64 = base64.fromByteArray(combinedData);

  // Ensure the encoded string length is a multiple of 4 by adding '=' characters
  const paddingLength = 4 - (encryptedDataBase64.length % 4);
  // const paddedEncryptedDataBase64 = encryptedDataBase64 + '='.repeat(paddingLength);
  const paddedEncryptedDataBase64 = encryptedDataBase64 + 'Z'.repeat(paddingLength);

  return paddedEncryptedDataBase64;
}

// Example usage:
// const encryptionKeyBase64 = 'T543oUJD9RzlE7YzlGesLpqCL988CV1Zavj7hvjpTQw='; // Your encryption key
// const dataToEncrypt = {
//   RecordId: '123',
//   ContactName: 'John Doe',
//   ContactPhoneNumber: '555-555-5555',
//   ProviderId: '789',
// };

// encryptWithManagedIV(dataToEncrypt, encryptionKeyBase64)
//   .then(encryptedData => {
//     //console.log('Encrypted Data:', encryptedData);
//   })
//   .catch(error => {
//     console.error('Error:', error);
//   });
